export default {
  removeHeader: Symbol.for('adc:fetch:wellKnownSymbols:removeHeader'),
}
